import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Button from "@mui/material/Button";
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';

const ReportGenerate = ({ excelData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";
  var wscols = [
    { wch: 30 },
    { wch: 50 },
    { wch: 60 },
    { wch: 15 },
    { wch: 60 },
    { wch: 25 },
  ];
  const addStyles = (workSheet) => {

    Object.entries(workSheet)
    .filter(([k, v]) => k.charAt(0) === "A")
    .forEach(([k, v]) => {
      if (v.v === "Year") {
        v.s = {
          fill: {
            fgColor: { rgb: "FFFFFF" },
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
          },
          font: {
            bold: false,
          }
        };
      } else {
        v.s = {
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText:true
          },
          width: {
            auto: true,
          },
          height:{
            auto:true
          }       
        };
      }
    });

    Object.entries(workSheet)
    .filter(([k, v]) => k.charAt(0) === "B")
    .forEach(([k, v]) => {
      if (v.v === "VendorName") {
        v.v = "Vendor";
        v.s = {
          fill: {
            fgColor: { rgb: "D0D8e2" },
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText:true
          },
          font: {
            bold: true,
          }
         
        };
      }
      else{
        v.s = {
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText:true
          },
          width: {
            auto: true,
          },
          height:{
            auto:true
          }
        };
      }
      
    });


    Object.entries(workSheet)
      .filter(([k, v]) => k.charAt(0) === "C")
      .forEach(([k, v]) => {
        if (v.v === "High") {
          v.s = {
            font: {
              sz: 12,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: { rgb: "E3A9A9" },
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
           
          };
        } else {
          v.s = {
            font: {
              sz: 12,
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
              wrapText:true
            },
            width: {
                auto: true,
              },
              height:{
                auto:true
              }
           
          };
        }
      });

      Object.entries(workSheet)
      .filter(([k, v]) => k.charAt(0) === "D")
      .forEach(([k, v]) => {        
        if (
          v.v === "Work in Progress" ||
          v.v === "In-Progress" ||
          v.v === "Annual Reassessment In Progress"
        ) {
          v.s = {
            font: {
              sz: 12,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: { rgb: "4F66D3" },
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
           
          };
        } 
        else {
          v.s = {
            font: {
              sz: 12,
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
            fill: {
              fgColor: { rgb: v.v === 'Bad' ? "EE4B2B" : v.v === "Good" ? '8FBC8B' : 'ffffff'},
            },
            width: {
                auto: true,
              },
              height:{
                auto:true
              }
           
          };
        }
      });

    Object.entries(workSheet)
      .filter(([k, v]) => k.charAt(0) === "E")
      .forEach(([k, v]) => {
        if (v.v === "High") {
          v.s = {
            font: {
              sz: 12,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: { rgb: "E3A9A9" },
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
           
          };
        } else {
          v.s = {
            font: {
              sz: 12,
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
              wrapText:true
            },
            width: {
                auto: true,
              },
              height:{
                auto:true
              }
           
          };
        }
      });
    Object.entries(workSheet)
      .filter(([k, v]) => k.charAt(0) === "F")
      .forEach(([k, v]) => {
        if (v.v === "High") {
          v.s = {
            font: {
              sz: 12,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: { rgb: "E3A9A9" },
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
           
          };
        } else {
          v.s = {
            font: {
              sz: 12,
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
              wrapText:true
            },
            width: {
                auto: true,
              },
              height:{
                auto:true
              }
           
          };
        }
      });

  };

  const excelDataLength = excelData.length;
  const rowHeight = Array(excelDataLength)
    .fill()
    .map((item) => ({ hpt: 30 }));

  // console.log("rowHeight")
  //console.log(rowHeight,excelDataLength)

  const exportTOExcel = async () => {
const transformedData = transformData(excelData);
    const ws = XLSX.utils.json_to_sheet(transformedData);
    console.log('Excel Data Json: ', transformedData);    
    console.log('Excel Data: ', ws);    
    const range = ws["!ref"];
    ws["!autofilter"] = { ref: range };
    addStyles(ws);
    ws["!cols"] = wscols;
    ws["!rows"] = rowHeight;
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const exelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([exelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const transformData = (excelData) => {    
    const newArray = excelData.map(obj => {    
        let newObj =  { ...obj, feedback : obj.feedback === 1 ? 'Good': 'Bad'  }        
        const { email, question, responseText, feedback, commentText, feedbackDate, feedbackTime, ...rest } = newObj;
        return { Email:email, Questions: question, Response: responseText, Feedback:feedback , Queries:commentText, Date: feedbackDate + ' ' + feedbackTime};
    });
    return newArray;
  };



  return (
    <div>
      <Button    
        style={{ backgroundColor: "transparent", fontSize: "14px", color: "#000000", padding: "10px", borderRadius:"6px"}}
        onClick={(e) => exportTOExcel(fileName)}
        className="export-button"
      >
      <VerticalAlignTopIcon className="export-icon"/>
        Export
      </Button>
    </div>
  );
};

export default ReportGenerate;
